import { render, staticRenderFns } from "./VirtualBackgroundSelector.vue?vue&type=template&id=766f8998&scoped=true"
import script from "./VirtualBackgroundSelector.vue?vue&type=script&lang=js"
export * from "./VirtualBackgroundSelector.vue?vue&type=script&lang=js"
import style0 from "./VirtualBackgroundSelector.vue?vue&type=style&index=0&id=766f8998&lang=css"
import style1 from "./VirtualBackgroundSelector.vue?vue&type=style&index=1&id=766f8998&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766f8998",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('766f8998')) {
      api.createRecord('766f8998', component.options)
    } else {
      api.reload('766f8998', component.options)
    }
    module.hot.accept("./VirtualBackgroundSelector.vue?vue&type=template&id=766f8998&scoped=true", function () {
      api.rerender('766f8998', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VirtualBackgroundSelector.vue"
export default component.exports